import React, { useEffect, useState } from "react";
import {
    Container,
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Add, Edit, Delete } from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { DateTimePicker } from "@mui/x-date-pickers";
import useAuthHeader from "react-auth-kit/hooks/useAuthHeader";
import { REACT_APP_BACKEND_URL } from "../../Utils/Language/urlBase";

const Expenses = () => {
    const [expenses, setExpenses] = useState([]);
    const [filteredExpenses, setFilteredExpenses] = useState([]);
    const [open, setOpen] = useState(false);
    const [isRefresh, setIsRefresh] = useState(false);
    const [currentExpense, setCurrentExpense] = useState({
        id: null,
        name: "",
        amount: "",
        addedTime: new Date(),
    });
    const authHeader = useAuthHeader();
    const [filter, setFilter] = useState({
        startDate: new Date(),
        endDate: new Date(),
    });

    const handleOpen = (
        expense = { id: null, name: "", amount: "", addedTime: new Date() }
    ) => {
        setCurrentExpense(expense);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setIsRefresh(!isRefresh);
        setCurrentExpense({
            id: null,
            name: "",
            amount: "",
            addedTime: new Date(),
        });
    };

    const handleSave = async () => {
        if (currentExpense.id) {
            await fetch(`/expenses/editExpense/${currentExpense.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    authorization: authHeader,
                },
            });
        }

        if (!currentExpense.id) {
            const response = await fetch(
                `${REACT_APP_BACKEND_URL}/expenses/addExpense`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: authHeader,
                    },
                    body: JSON.stringify(currentExpense),
                }
            );
            console.log(response);
        }
        handleClose();
    };

    const handleDelete = async (id) => {
        await fetch(`/api/expenses/deleteExpense/${id}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            },
        });
        handleClose();
    };

    const handleFilterChange = (field, value) => {
        setFilter({ ...filter, [field]: value });
    };

    useEffect(() => {
        const fetchExpenses = async () => {
            const response = await fetch(
                `${REACT_APP_BACKEND_URL}/expenses/getAllExpenses`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: authHeader,
                    },
                    body: JSON.stringify({
                        dateRange: filter,
                    }),
                }
            );
            if (response.ok) {
                const data = await response.json();
                console.log(data);
                setExpenses(data.expense);
            }
        };
        fetchExpenses();
    }, [isRefresh, authHeader, filter]);

    return (
        <Container>
            <h1>Expenses</h1>
            <div
                style={{
                    margin: "20px 0",
                    display: "flex",
                    justifyContent: "space-between",
                }}
            >
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<Add />}
                    onClick={() => handleOpen()}
                    size="small"
                >
                    Add Expense
                </Button>
                <div
                    style={{
                        display: "flex",
                        gap: "10px",
                    }}
                >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Start Date"
                            value={dayjs(filter.startDate)}
                            onChange={(date) =>
                                handleFilterChange("startDate", date)
                            }
                        />
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="End Date"
                            value={dayjs(filter.endDate)}
                            onChange={(date) =>
                                handleFilterChange("endDate", date)
                            }
                        />
                    </LocalizationProvider>
                </div>
            </div>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell>Amount</TableCell>
                        <TableCell>Date</TableCell>
                        <TableCell>Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {(filteredExpenses.length
                        ? filteredExpenses
                        : expenses
                    ).map((exp) => (
                        <TableRow key={exp.id}>
                            <TableCell>{exp.name}</TableCell>
                            <TableCell>{exp.amount}</TableCell>
                            <TableCell>
                                {new Date(exp.addedTime).toLocaleDateString()}
                            </TableCell>
                            <TableCell>
                                <IconButton onClick={() => handleOpen(exp)}>
                                    <Edit />
                                </IconButton>
                                <IconButton
                                    onClick={() => handleDelete(exp.id)}
                                >
                                    <Delete />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>
                    {currentExpense.id ? "Edit Expense" : "Add Expense"}
                </DialogTitle>
                <DialogContent>
                    <TextField
                        margin="dense"
                        label="Name"
                        fullWidth
                        value={currentExpense.name}
                        onChange={(e) =>
                            setCurrentExpense({
                                ...currentExpense,
                                name: e.target.value,
                            })
                        }
                    />
                    <TextField
                        margin="dense"
                        label="Amount"
                        fullWidth
                        value={currentExpense.amount}
                        onChange={(e) =>
                            setCurrentExpense({
                                ...currentExpense,
                                amount: e.target.value,
                            })
                        }
                    />
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                            label="Date"
                            value={dayjs(currentExpense.addedTime)}
                            onChange={(date) =>
                                setCurrentExpense({
                                    ...currentExpense,
                                    addedTime: date,
                                })
                            }
                        />
                    </LocalizationProvider>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleSave} color="primary">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
};

export default Expenses;
